export enum BaseGender {
  'Frau' = 1,
  'Herr' = 2,
  'Diverse' = 3,
}
